import {
  queryGradeApi,
  addGradeApi,
  updateGradeApi,
  deleteUserGradeApi,
  changeBrandUserGradeApi,
  disableGradeApi,
  enableGradeApi,
  queryUserApi,
  addBrandUserTagApi,
  updateBrandUserTagApi,
  getBrandUserTagByIdApi,
  deleteBrandUserTagApi,
  queryBrandUserTagApi,
  addUserApi,
  updateUserApi,
  queryOrderWaterApi,
  getBrandUserByIdApi,
  getTicketUseCountApi,
  setBrandUserByIdApi,
  setUserExtendConfigApi,
  accountAdjustmentApi,
  integralAdjustmentApi,
  getBrandUserTicketListApi,
  adjustTicketForAddApi,
  adjustTicketForReduceApi,
  queryUserAccountWaterApi,
  queryOtherOrderListApi,
  getBrandUserTagRelListApi,
  saveBrandUserTagRelApi,
  batchAddBrandUserTagRelApi,
  getBusinessOpporImportByIdApi,
  getBrandUserCardListApi,
  setBrandDefaulUserGradeByIdApi,
  queryCompanyUserApi,
  getCompanyUserCardListApi,
  addCompanyUserGradeApi,
  updateCompanyUserGradeApi,
  deleteCompanyUserGradeApi,
  queryUserGuestApi,
  getUserInfoByIdApi,
  updateUserByIdApi,
  setUserByIdApi,
  setBrandUserServeStaffIdApi,
  queryUserEnterpriseApi,
  setUserEnterpriseMsgApi,
  queryUserJobWantedMsgApi,
  setUserJobWantedMsgMsgApi,
  setRecruitPostMsgApi,
  queryRecruitPostApplicationApi,
  queryRecruitPostApi,
  getUserEnterpriseByCondApi,
  setUserJobWantedMsgApi,
  getRecruitPostByIdApi,
  userDepositAdjustApi,
  queryUserDepositAdjustWaterApi,
  setUserLimitBuyAdjustApi,
  queryUserLimitBuyAdjustApi,
  queryUserSiteChangeApplyApi,
  checkUserSiteChangeApplyApi,
  addUserGradeUpgradeRuleApi,
  deleteUserGradeUpgradeRuleApi,
  updateUserGradeUpgradeRuleApi,
  getUserGradeUpgradeRuleByIdApi,
  queryUserGradeUpgradeRuleApi,
  setUserGradeUpgradeRuleMsgApi,
  setBrandUserMsgApi,
  queryUserGxOrderApi,
  setBrandUserTagApi,
  setDownGradeRuleConfigApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  分页查询会员等级信息
  async queryGradeAction(context, param) {
    const res = await queryGradeApi(param)
    return res
  },
  //  新增会员等级信息
  async addGradeAction(context, param) {
    const res = await addGradeApi(param)
    return res
  },
  //  修改会等级信息
  async updateGradeAction(context, param) {
    const res = await updateGradeApi(param)
    return res
  },
  //  删除会员等级
  async deleteUserGradeAction(context, param) {
    const res = await deleteUserGradeApi(param)
    return res
  },
  //  切换等级
  async changeBrandUserGradeAction(context, param) {
    const res = await changeBrandUserGradeApi(param)
    return res
  },
  //  设置停止
  async disableGradeAction(context, param) {
    const res = await disableGradeApi(param)
    return res
  },
  //  设置启用
  async enableGradeAction(context, param) {
    const res = await enableGradeApi(param)
    return res
  },
  //  查询会员分页
  async queryUserAction(context, param) {
    const res = await queryUserApi(param)
    return res
  },
  //  添加品牌用户标签信息
  async addBrandUserTagAction(context, param) {
    const res = await addBrandUserTagApi(param)
    return res
  },
  //  修改品牌用户标签信息
  async updateBrandUserTagAction(context, param) {
    const res = await updateBrandUserTagApi(param)
    return res
  },
  //  根据id获取品牌用户标签信息
  async getBrandUserTagByIdAction(context, param) {
    const res = await getBrandUserTagByIdApi(param)
    return res
  },
  //  查询品牌用户标签列表信息
  async queryBrandUserTagAction(context, param) {
    const res = await queryBrandUserTagApi(param)
    return res
  },
  //  删除品牌用户标签信息
  async deleteBrandUserTagAction(context, param) {
    const res = await deleteBrandUserTagApi(param)
    return res
  },
  //  添加会员信息
  async addUserAction(context, param) {
    const res = await addUserApi(param)
    return res
  },
  //  修改会员信息
  async updateUserAction(context, param) {
    const res = await updateUserApi(param)
    return res
  },
  //  订单流水
  async queryOrderWaterAction(context, param) {
    const res = await queryOrderWaterApi(param)
    return res
  },
  //  订单流水
  async getBrandUserByIdAction(context, param) {
    const res = await getBrandUserByIdApi(param)
    return res
  },
  //  获取用户电子券统计(支持通用券)
  async getTicketUseCountAction(context, param) {
    const res = await getTicketUseCountApi(param)
    return res
  },
  //  设置会员状态
  async setBrandUserByIdAction(context, param) {
    const res = await setBrandUserByIdApi(param)
    return res
  },
  //  设置会员拓展信息
  async setUserExtendConfigAction(context, param) {
    const res = await setUserExtendConfigApi(param)
    return res
  },
  //  调账
  async accountAdjustmentAction(context, param) {
    const res = await accountAdjustmentApi(param)
    return res
  },
  //  调积分
  async integralAdjustmentAction(context, param) {
    const res = await integralAdjustmentApi(param)
    return res
  },
  // 查询会员拥有的优惠券
  async getBrandUserTicketListAction(context, param) {
    const res = await getBrandUserTicketListApi(param)
    return res
  },
  // 会员调券——增加
  async adjustTicketForAddAction(context, param) {
    const res = await adjustTicketForAddApi(param)
    return res
  },
  // 会员调券——扣除
  async adjustTicketForReduceAction(context, param) {
    const res = await adjustTicketForReduceApi(param)
    return res
  },
  // 会员账户流水
  async queryUserAccountWaterAction(context, param) {
    const res = await queryUserAccountWaterApi(param)
    return res
  },
  // 会员统计
  async queryOtherOrderListAction(context, param) {
    const res = await queryOtherOrderListApi(param)
    return res
  },
  // 获取品牌用户标签关联列表
  async getBrandUserTagRelListAction(context, param) {
    const res = await getBrandUserTagRelListApi(param)
    return res
  },
  // 批量添加品牌用户标签关联
  async batchAddBrandUserTagRelAction(context, param) {
    const res = await batchAddBrandUserTagRelApi(param)
    return res
  },
  // 保存品牌用户标签关联
  async saveBrandUserTagRelAction(context, param) {
    const res = await saveBrandUserTagRelApi(param)
    return res
  },
  // 根据id获取导入记录信息
  async getBusinessOpporImportByIdAction(context, param) {
    const res = await getBusinessOpporImportByIdApi(param)
    return res
  },
  // 获取会员卡信息
  async getBrandUserCardListAction(context, param) {
    const res = await getBrandUserCardListApi(param)
    return res
  },
  // 设置默认等级
  async setBrandDefaulUserGradeByIdAction(context, param) {
    const res = await setBrandDefaulUserGradeByIdApi(param)
    return res
  },
  // 查询公司会员
  async queryCompanyUserAction(context, param) {
    const res = await queryCompanyUserApi(param)
    return res
  },
  // 全品牌会员卡数量
  async getCompanyUserCardListAction(context, param) {
    const res = await getCompanyUserCardListApi(param)
    return res
  },
  // 添加公司用户等级
  async addCompanyUserGradeAction(context, param) {
    const res = await addCompanyUserGradeApi(param)
    return res
  },
  // 更新公司用户等级
  async updateCompanyUserGradeAction(context, param) {
    const res = await updateCompanyUserGradeApi(param)
    return res
  },
  // 删除公司会员等级
  async deleteCompanyUserGradeAction(context, param) {
    const res = await deleteCompanyUserGradeApi(param)
    return res
  },
  // 查询用户嘉宾
  async queryUserGuestAction(context, param) {
    const res = await queryUserGuestApi(param)
    return res
  },
  // 根据userID获取用户信息
  async getUserInfoByIdAction(context, param) {
    const res = await getUserInfoByIdApi(param)
    return res
  },
  // 根据用户id更新用户信息
  async updateUserByIdAction(context, param) {
    const res = await updateUserByIdApi(param)
    return res
  },
  // 根据用户id设置用户信息
  async setUserByIdAction(context, param) {
    const res = await setUserByIdApi(param)
    return res
  },
  // 设置品牌用户服务员工id接口
  async setBrandUserServeStaffIdAction(context, param) {
    const res = await setBrandUserServeStaffIdApi(param)
    return res
  },
  // 查询用户企业信息
  async queryUserEnterpriseAction(context, param) {
    const res = await queryUserEnterpriseApi(param)
    return res
  },
  // 根据条件获取用户企业信息
  async getUserEnterpriseByCondAction(context, param) {
    const res = await getUserEnterpriseByCondApi(param)
    return res
  },
  // 设置用户企业信息
  async setUserEnterpriseMsgAction(context, param) {
    const res = await setUserEnterpriseMsgApi(param)
    return res
  },
  // 查询用户求职信息
  async queryUserJobWantedMsgAction(context, param) {
    const res = await queryUserJobWantedMsgApi(param)
    return res
  },
  // 根据条件获取用户求职信息
  async setUserJobWantedMsgMsgAction(context, param) {
    const res = await setUserJobWantedMsgMsgApi(param)
    return res
  },
  // 设置用户求职信息
  async setUserJobWantedMsgAction(context, param) {
    const res = await setUserJobWantedMsgApi(param)
    return res
  },
  // 设置招聘岗位信息
  async setRecruitPostMsgAction(context, param) {
    const res = await setRecruitPostMsgApi(param)
    return res
  },
  // 根据id获取招聘岗位
  async getRecruitPostByIdAction(context, param) {
    const res = await getRecruitPostByIdApi(param)
    return res
  },
  // 查询招聘岗位
  async queryRecruitPostAction(context, param) {
    const res = await queryRecruitPostApi(param)
    return res
  },
  // 查询招聘岗位应聘信息
  async queryRecruitPostApplicationAction(context, param) {
    const res = await queryRecruitPostApplicationApi(param)
    return res
  },
  // 用户押金调整
  async userDepositAdjustAction(context, param) {
    const res = await userDepositAdjustApi(param)
    return res
  },
  //  查询用户押金调整流水
  async queryUserDepositAdjustWaterAction(context, param) {
    const res = await queryUserDepositAdjustWaterApi(param)
    return res
  },
  //  设置用户限购调整
  async setUserLimitBuyAdjustAction(context, param) {
    const res = await setUserLimitBuyAdjustApi(param)
    return res
  },
  //  查询用户限购调整记录
  async queryUserLimitBuyAdjustAction(context, param) {
    const res = await queryUserLimitBuyAdjustApi(param)
    return res
  },
  //  查询用户站点变更申请
  async queryUserSiteChangeApplyAction(context, param) {
    const res = await queryUserSiteChangeApplyApi(param)
    return res
  },
  //  审核用户站点变更申请
  async checkUserSiteChangeApplyAction(context, param) {
    const res = await checkUserSiteChangeApplyApi(param)
    return res
  },
  //  添加用户等级升级规则
  async addUserGradeUpgradeRuleAction(context, param) {
    const res = await addUserGradeUpgradeRuleApi(param)
    return res
  },
  //  删除用户等级升级规则
  async deleteUserGradeUpgradeRuleAction(context, param) {
    const res = await deleteUserGradeUpgradeRuleApi(param)
    return res
  },
  //  修改用户等级升级规则
  async updateUserGradeUpgradeRuleAction(context, param) {
    const res = await updateUserGradeUpgradeRuleApi(param)
    return res
  },
  //  根据id获取用户等级升级规则
  async getUserGradeUpgradeRuleByIdAction(context, param) {
    const res = await getUserGradeUpgradeRuleByIdApi(param)
    return res
  },
  //  查询用户等级升级规则
  async queryUserGradeUpgradeRuleAction(context, param) {
    const res = await queryUserGradeUpgradeRuleApi(param)
    return res
  },
  //  设置用户等级升级规则
  async setUserGradeUpgradeRuleMsgAction(context, param) {
    const res = await setUserGradeUpgradeRuleMsgApi(param)
    return res
  },
  //  设置品牌用户信息
  async setBrandUserMsgAction(context, param) {
    const res = await setBrandUserMsgApi(param)
    return res
  },
  //  查询用户高校订单
  async queryUserGxOrderAction(context, param) {
    const res = await queryUserGxOrderApi(param)
    return res
  },
  //  设置品牌用户标签信息
  async setBrandUserTagAction(context, param) {
    const res = await setBrandUserTagApi(param)
    return res
  },
  //  设置降级规则配置
  async setDownGradeRuleConfigAction(context, param) {
    const res = await setDownGradeRuleConfigApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
